import { default as sharedStores } from '🔗/stores';

import useNavStore from '@/stores/nav';
import useShareStore from '@/stores/share';

const stores = {
    ...sharedStores,
    nav: useNavStore,
    share: useShareStore
}

export default stores;
